import React from "react";
import "./card-style.css";

function CardInfoMes(props) {
    return (
        <div className="container-cards-historico" key={Math.random()}>
            <div className="tabela-card">
                <b>Codigo Disciplina</b>
                <b>Disciplina</b>
                <b>Período</b>
                <b>Créditos</b>
                <b>C.H.</b>
                <b>Status</b>
                <b>Nota</b>
            </div>
            {props.data.map((item, index) => (
                <>
                    <div className="item-historico" key={index + Math.random()}>
                        <div className="tabela-card">
                            <p>{item.cod_disciplina}</p>
                            <p>{item.disciplina}</p>
                            <p>{item.periodo}</p>
                            <p>{item.creditos}</p>
                            <p>{item.carga_horaria}</p>
                            <p>{item.status}</p>
                            <p>{item.nota}</p>
                            <br/>
                        </div>
                    </div>
                </>
            ))}
        </div>
    );
}

export default CardInfoMes;
